import { render, staticRenderFns } from "./CotizrColumnHeader.vue?vue&type=template&id=ccaae530&"
import script from "./CotizrColumnHeader.vue?vue&type=script&lang=js&"
export * from "./CotizrColumnHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports